import './language-switcher.scss';

import { useState } from 'react';

import { Languages, SUPPORTED_LANGUAGES } from '@/shared/constants';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { Button, OutsideClickHandler } from '@/shared/ui';

interface IProps {
  className: string;
}

const LanguageSwitcher: React.FC<IProps> = ({ className }) => {
  const { changeLanguage, currentLang } = useAppNavigate();

  const [isOpened, setIsOpened] = useState(false);

  const handleSelect = (language: Languages) => {
    changeLanguage(language);
    setIsOpened(false);
  };

  return (
    <div className={`language-switcher ${className}`}>
      <Button
        className="language-switcher__button"
        onClick={() => setIsOpened(!isOpened)}
        type="button"
        size="small"
        isSquare
      >
        {currentLang}
      </Button>

      <OutsideClickHandler onOutsideClick={() => setIsOpened(false)}>
        <div
          className={`language-switcher__popup ${isOpened ? 'language-switcher__popup--shown' : ''}`}
        >
          <ul className="language-switcher__list">
            {SUPPORTED_LANGUAGES.map((option) => (
              <li
                onClick={() => handleSelect(option)}
                className={`language-switcher__item ${
                  currentLang === option
                    ? 'language-switcher__item--selected'
                    : ''
                }`}
                key={option}
              >
                {option}
              </li>
            ))}
          </ul>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default LanguageSwitcher;
